var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f90669;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.77,31.19c5.64-5.64,14.83-5.64,20.47,0,5.64,5.64,5.64,14.83,0,20.47l-10.23,10.23-10.23-10.23c-5.64-5.64-5.64-14.83,0-20.47M20.71,12.13h0c-16.18,16.18-16.18,42.4,0,58.58l29.29,29.29,29.29-29.29c16.18-16.18,16.18-42.4,0-58.58h0c-16.18-16.18-42.4-16.18-58.58,0h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/Maps.a7785b3630b6306ca29465c573012365.svg";
export { ForwardRef as ReactComponent };